// Strip periods for consistent formatting
export const formatHTS = (htsNumber?: string): string => {
  if (typeof htsNumber !== 'string') {
    return '';
  }

  return htsNumber.replace(/\./g, '') ?? '';
};
